// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"373e8be0","174":"50dc9ae4","488":"1816def7","605":"7fa51c44","672":"667db37d","725":"36f2fe49","728":"ab4882c5","741":"321b7f02","894":"53df0ac6"}[chunkId] + ".chunk.js";
};